import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HubAuthorizationComponent } from '../../components/hub-authorization/hub-authorization.component';
import { AuthorizationScenario } from '../../enum/authorization-scenario.enum';
import { DialogsService } from '../dialogs.service';

@Injectable()
export class AuthorizationWraperService {

    private dialogReference: any;

    constructor(
        private dialogsService: DialogsService,
    ) { }

    /**
     * requisita ao usuário que use um token para authorização
     * @param scenario cenário de authorização.
     */
    public requestUserAuthorization(
        scenario: AuthorizationScenario = AuthorizationScenario.AuthorizeAction,
        hasBackdrop?: boolean,
        onBackdropClick?: () => void,
    ): MatDialogRef<HubAuthorizationComponent> {
        this.dialogReference = this.dialogsService.showComponentAsAsidePanel(
            HubAuthorizationComponent,
            true,
            scenario,
            undefined,
            hasBackdrop,
            onBackdropClick,
        );
        return this.dialogReference;
    }
}
